/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { utils } from '@broadleaf/admin-components';

const { Environment } = utils;

/**
 * Returns the domain expected for redirect URLs provided by the PayPal API.
 * These URLs are used to take users to the PayPal dashboard.
 *
 * Uses the `PAYPAL_REFERRALS_REDIRECT_URL_DOMAIN` environment variable.
 *
 * @return {String}
 */
export function getExpectAccountRedirectUrlDomain() {
  return Environment.get(
    'PAYPAL_REFERRALS_REDIRECT_URL_DOMAIN',
    /^https:\/\/\S+?paypal\.com.*$/
  );
}

/**
 * Determines whether the given URL is valid to redirect to. These URLs are
 * used to take users to the PayPal dashboard
 *
 * @param {String} url - URL in question
 *
 * @return {Boolean}
 */
export function validateAccountRedirectUrl(url) {
  return !!url && getExpectAccountRedirectUrlDomain().test(url);
}
